/* ══════════════════════════════════════════════════════
   RedEvidence — LENA Demo Chat (functional)
   Powers both Hero iPhone mockup + LENA section chat.
   3-message limit, localStorage persistence.
   ══════════════════════════════════════════════════════ */

(function () {
  'use strict';

  const API_URL = 'https://srsslpmowcktescdguge.supabase.co/functions/v1/lena-demo';
  const MAX_MESSAGES = 3;
  const STORAGE_KEY = 're_demo_chat';

  // ── State ──
  let chatHistory = []; // { role, content }
  let userMsgCount = 0;
  let isExhausted = false;
  let isBusy = false;

  // Restore from localStorage
  try {
    const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
    if (saved && Array.isArray(saved.history)) {
      chatHistory = saved.history;
      userMsgCount = saved.userMsgCount || 0;
      isExhausted = userMsgCount >= MAX_MESSAGES;
    }
  } catch {}

  // ── DOM refs (populated on DOMContentLoaded) ──
  const instances = []; // { body, input, sendBtn, lockOverlay, id }

  const WELCOME_MSG = 'Willkommen, Ermittler. Ich bin LENA. Kostprobe aus AKTE 001: Der Direktor des Leipziger Schauspielhauses stirbt am Abend der Premiere in seiner Garderobe. Suizid, sagt die Polizei. Fünf Verdächtige. Frag mich, was du willst — ich antworte frei, nicht aus der Konserve.';

  function initInstance(id, bodyEl, inputEl, sendBtn, lockOverlay) {
    const inst = { id, body: bodyEl, input: inputEl, sendBtn, lockOverlay };
    instances.push(inst);

    // Always show LENA welcome message first
    appendMessage(inst, 'assistant', WELCOME_MSG, false, '09:41');

    // Render existing history
    chatHistory.forEach(msg => {
      appendMessage(inst, msg.role, msg.content, false, msg.t);
    });

    if (isExhausted) showLock(inst);

    // Wire events
    if (sendBtn) sendBtn.addEventListener('click', () => handleSend(inst));
    if (inputEl) inputEl.addEventListener('keydown', e => {
      if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); handleSend(inst); }
    });
  }

  // Uhrzeit wie im echten Chat. Feste Startzeit statt Date.now(), damit beide
  // Instanzen dieselbe Uhr zeigen und der Screenshot reproduzierbar bleibt.
  let clockMin = 0;
  function nextTime() {
    clockMin += 2;
    const m = (41 + clockMin) % 60, h = 9 + Math.floor((41 + clockMin) / 60);
    return String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0');
  }

  function appendMessage(inst, role, text, animate, stamp) {
    const { body } = inst;
    if (!body) return;

    if (role === 'user') {
      const wrap = document.createElement('div');
      wrap.className = 'demo-msg demo-msg-user' + (animate ? ' demo-msg-anim' : '');
      const bubble = document.createElement('div');
      bubble.className = 'demo-user-bubble';
      bubble.textContent = text;
      wrap.appendChild(bubble);
      if (stamp) {
        const t = document.createElement('div');
        t.className = 'demo-msg-time demo-msg-time-right';
        t.textContent = stamp;
        wrap.appendChild(t);
      }
      body.appendChild(wrap);
      if (animate) requestAnimationFrame(() => wrap.classList.add('demo-msg-visible'));
      else wrap.classList.add('demo-msg-visible');
    } else {
      const wrap = document.createElement('div');
      wrap.className = 'demo-msg demo-msg-ai' + (animate ? ' demo-msg-anim' : '');
      wrap.innerHTML =
        '<div class="demo-ai-row">' +
          '<div class="demo-ai-avatar"><span>KI</span></div>' +
          '<div class="demo-ai-col">' +
            '<div class="demo-ai-label">LENA</div>' +
            '<div class="demo-ai-bubble">' + escapeHtml(text) + '</div>' +
            (stamp ? '<div class="demo-msg-time">' + stamp + '</div>' : '') +
          '</div>' +
        '</div>';
      body.appendChild(wrap);
      if (animate) requestAnimationFrame(() => wrap.classList.add('demo-msg-visible'));
      else wrap.classList.add('demo-msg-visible');
    }
    body.scrollTop = body.scrollHeight;
  }

  function showTyping(inst) {
    const wrap = document.createElement('div');
    wrap.className = 'demo-msg demo-msg-ai demo-msg-visible demo-typing-wrap';
    wrap.innerHTML =
      '<div class="demo-ai-row">' +
        '<div class="demo-ai-avatar"><span>KI</span></div>' +
        '<div class="demo-ai-col">' +
          '<div class="demo-ai-label">LENA</div>' +
          '<div class="demo-ai-bubble demo-typing-bubble">' +
            '<span class="demo-dot"></span><span class="demo-dot"></span><span class="demo-dot"></span>' +
          '</div>' +
        '</div>' +
      '</div>';
    inst.body.appendChild(wrap);
    inst.body.scrollTop = inst.body.scrollHeight;
    return wrap;
  }

  function showLock(inst) {
    isExhausted = true;
    if (inst.input) inst.input.disabled = true;
    if (inst.sendBtn) inst.sendBtn.disabled = true;

    // Show CTA overlay
    if (inst.lockOverlay) {
      inst.lockOverlay.classList.add('demo-lock-visible');
    } else {
      // Create inline lock
      const cta = document.createElement('div');
      cta.className = 'demo-lock-cta demo-lock-visible';
      cta.innerHTML =
        '<div class="demo-lock-text">Demo beendet — 3 Nachrichten erreicht</div>' +
        // Anker heißt #re-pricing, nicht #pricing — mit dem alten Wert führte
        // der Knopf im Moment der höchsten Kaufabsicht nirgendwohin.
        // Preis: AKTE 001 kostet 29 € (von 39 €). Die 49 € stammten aus der
        // Zeit vor dem Digital-Pivot.
        '<a href="#re-pricing" class="demo-lock-btn">Weiter ermitteln — 29 €</a>';
      inst.body.appendChild(cta);
    }
    inst.body.scrollTop = inst.body.scrollHeight;
  }

  async function handleSend(inst) {
    if (isBusy || isExhausted) return;
    const text = inst.input?.value?.trim();
    if (!text) return;

    isBusy = true;
    inst.input.value = '';
    if (inst.sendBtn) inst.sendBtn.disabled = true;

    // Add to all instances
    userMsgCount++;
    chatHistory.push({ role: 'user', content: text, t: null });
    const userStamp = nextTime();
    instances.forEach(i => appendMessage(i, 'user', text, true, userStamp));

    // Show typing in all instances
    const typingEls = instances.map(i => showTyping(i));

    try {
      const res = await fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ messages: chatHistory }),
      });
      const data = await res.json();

      // Remove typing
      typingEls.forEach(t => t?.remove());

      if (data.error) {
        // Fehlversuch zurückrollen: Die unbeantwortete Frage darf weder das
        // 3-Nachrichten-Budget kosten noch in der Historie hängen bleiben —
        // sonst brickt ein einziger Aussetzer die Kostprobe dauerhaft
        // (localStorage) und der nächste Send schickt doppelte user-Rollen.
        chatHistory.pop();
        userMsgCount--;
        const errText = data.error;
        instances.forEach(i => appendMessage(i, 'assistant', errText, true));
      } else {
        const reply = data.reply || 'Verbindung unterbrochen.';
        const aiStamp = nextTime();
        chatHistory[chatHistory.length - 1].t = userStamp;
        chatHistory.push({ role: 'assistant', content: reply, t: aiStamp });
        instances.forEach(i => appendMessage(i, 'assistant', reply, true, aiStamp));

        if (data.demo_exhausted || userMsgCount >= MAX_MESSAGES) {
          instances.forEach(i => showLock(i));
        }
      }
    } catch {
      // Netzfehler: gleicher Rollback wie oben.
      chatHistory.pop();
      userMsgCount--;
      typingEls.forEach(t => t?.remove());
      const fallback = 'Verbindung unterbrochen. Versuche es gleich nochmal.';
      instances.forEach(i => appendMessage(i, 'assistant', fallback, true));
    }

    // Persist
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        history: chatHistory.slice(-12),
        userMsgCount,
      }));
    } catch {}

    isBusy = false;
    if (!isExhausted && inst.sendBtn) inst.sendBtn.disabled = false;
    if (!isExhausted && inst.input) inst.input.focus();
  }

  function escapeHtml(s) {
    return s.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  // ── Init on DOMContentLoaded ──
  document.addEventListener('DOMContentLoaded', () => {
    // Hero iPhone mockup
    const heroBody = document.getElementById('demoChatHero');
    const heroInput = document.getElementById('demoChatHeroInput');
    const heroSend = document.getElementById('demoChatHeroSend');
    if (heroBody) initInstance('hero', heroBody, heroInput, heroSend, null);

    // LENA section iPhone mockup
    const lenaBody = document.getElementById('demoChatLena');
    const lenaInput = document.getElementById('demoChatLenaInput');
    const lenaSend = document.getElementById('demoChatLenaSend');
    if (lenaBody) initInstance('lena', lenaBody, lenaInput, lenaSend, null);
  });
})();
